import React from 'react'

export const ExitCrossIcon: React.FC = () => (
	<svg
		id='Group_4794'
		data-name='Group 4794'
		xmlns='http://www.w3.org/2000/svg'
		width='25.488'
		height='25.488'
		className='exitcrossicon-svg'
		viewBox='0 0 25.488 25.488'>
		<g id='Group_4465' data-name='Group 4465'>
			<g id='Group_4464' data-name='Group 4464'>
				<path
					id='Path_3370'
					data-name='Path 3370'
					d='M403.538,236.193a12.744,12.744,0,1,0,12.744,12.744A12.744,12.744,0,0,0,403.538,236.193Zm0,23.514a10.77,10.77,0,1,1,10.77-10.77h0A10.782,10.782,0,0,1,403.538,259.707Z'
					transform='translate(-390.794 -236.193)'
					fill='#fff'
				/>
			</g>
		</g>
		<g
			id='Group_4467'
			data-name='Group 4467'
			transform='translate(7.078 7.079)'>
			<g id='Group_4466' data-name='Group 4466'>
				<path
					id='Path_3371'
					data-name='Path 3371'
					d='M407.066,243.644l-3.53,3.53-3.53-3.53a1.25,1.25,0,1,0-1.767,1.768l3.529,3.529-3.527,3.528a1.25,1.25,0,1,0,1.768,1.767l3.53-3.53,3.53,3.53a1.25,1.25,0,1,0,1.768-1.767l-3.533-3.533,3.53-3.53a1.25,1.25,0,0,0-1.768-1.768Z'
					transform='translate(-397.872 -243.272)'
					fill='#fff'
				/>
			</g>
		</g>
	</svg>
)

export const SaveIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='23.672'
		height='23.405'
		className='saveicon-svg'
		viewBox='0 0 23.672 23.405'>
		<g id='Group_4791' data-name='Group 4791' transform='translate(1.25 1.25)'>
			<path
				id='Path_3385'
				data-name='Path 3385'
				d='M1671.145,75.2V54.291h13.72l7.452,7.452V75.2Z'
				transform='translate(-1671.145 -54.291)'
				fill='none'
				stroke='#fff'
				stroke-linejoin='round'
				stroke-width='2.5'
			/>
			<path
				id='Path_3386'
				data-name='Path 3386'
				d='M1675.4,72.617v-8.13h8.511v8.13'
				transform='translate(-1670.07 -51.712)'
				fill='none'
				stroke='#fff'
				stroke-linejoin='round'
				stroke-width='2.5'
			/>
		</g>
	</svg>
)

export const DownloadIcon: React.FC = () => (
	<svg
		id='_001-direct-download'
		data-name='001-direct-download'
		xmlns='http://www.w3.org/2000/svg'
		width='27.578'
		height='22.982'
		className='downloadicon-svg'
		viewBox='0 0 27.578 22.982'>
		<path
			id='Path_3393'
			data-name='Path 3393'
			d='M12.895,18.087a.86.86,0,0,1-.623-.267L6.239,11.5a.862.862,0,0,1,.623-1.457h3.16V3.436A1.438,1.438,0,0,1,11.458,2h2.873a1.438,1.438,0,0,1,1.436,1.436v6.607h3.16A.862.862,0,0,1,19.55,11.5l-6.033,6.32A.86.86,0,0,1,12.895,18.087Z'
			transform='translate(0.894 -2)'
			fill='#cfcbdc'
		/>
		<path
			id='Path_3394'
			data-name='Path 3394'
			d='M25.567,22.6H2.011A2.013,2.013,0,0,1,0,20.585v-.575A2.013,2.013,0,0,1,2.011,18H25.567a2.013,2.013,0,0,1,2.011,2.011v.575A2.013,2.013,0,0,1,25.567,22.6Z'
			transform='translate(0 0.385)'
			fill='#cfcbdc'
		/>
	</svg>
)

export const ReGeneratedIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='22.161'
		height='25.472'
		className='regeneratedicon-svg'
		viewBox='0 0 22.161 25.472'>
		<g id='reload' transform='translate(-31.817 0)'>
			<path
				id='Path_3562'
				data-name='Path 3562'
				d='M44.115,25.4a11.141,11.141,0,0,0-1.15-22.208V.2a.215.215,0,0,0-.349-.151L36.446,4.577a.19.19,0,0,0,0,.307l6.171,4.532a.217.217,0,0,0,.349-.151V6.274a8.069,8.069,0,1,1-8.1,9.355,1.534,1.534,0,0,0-3.034.463A11.157,11.157,0,0,0,44.115,25.4Z'
				transform='translate(0 0)'
				fill='#ff3067'
			/>
		</g>
	</svg>
)
